(function () {
  // Mobile menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Product gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-main]');
    gal.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-thumb');
        main.removeAttribute('srcset');
        main.alt = btn.getAttribute('data-alt') || main.alt;
        gal.querySelectorAll('[data-thumb]').forEach(function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
      });
    });
  });

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var min = parseInt(input.min || '0', 10);
        var v = (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-step'), 10);
        input.value = Math.max(min, v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Variant selector updates the URL and price
  var vs = document.querySelector('[data-variant-select]');
  if (vs) {
    vs.addEventListener('change', function () {
      var opt = vs.options[vs.selectedIndex];
      var price = document.querySelector('[data-price]');
      if (price && opt.getAttribute('data-price')) price.firstChild.nodeValue = opt.getAttribute('data-price') + ' ';
      var btn = document.querySelector('[data-add]');
      if (btn) {
        var ok = opt.getAttribute('data-available') === 'true';
        btn.disabled = !ok;
        btn.textContent = ok ? 'Add to cart' : 'Sold out';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', vs.value);
      window.history.replaceState({}, '', url.toString());
    });
  }
})();
